import format from 'date-fns/format';
import isSameDay from 'date-fns/isSameDay';
import parseISO from 'date-fns/parseISO';

import { DateFormat, formatDate } from '@lyearn/core/utils/date/formatDate';
import { formatRange, RangeFormat } from '@lyearn/core/utils/date/formatRange';
import { EventUnion } from '@/types/schema';

export const getDateLabel = (event: EventUnion, isMobile: boolean) => {
  if (!event || !event.startTime) {
    return null;
  }

  const startTime = parseISO(new Date(event.startTime).toISOString());
  const endTime = event.endTime ? parseISO(new Date(event.endTime).toISOString()) : null;

  if (!endTime) {
    return `${formatDate(startTime, DateFormat.DateTime)}`;
  }

  if (isSameDay(startTime, endTime)) {
    return formatRange(startTime, endTime, RangeFormat.Time);
  } else {
    return isMobile
      ? `${format(startTime, 'h:mma')} - ${format(endTime, 'd MMM, h:mm a')}`
      : `${format(startTime, 'd MMM, h:mma')} - ${format(endTime, 'd MMM, h:mm a')}`;
  }
};
